/* assets/custom-cart.js */
(() => {
  if (window.__customCartInit) return;
  window.__customCartInit = true;

  // ------------------------
  // Utils
  // ------------------------
  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const dispatch = (el, name, detail, bubbles = true) =>
    el && el.dispatchEvent(new CustomEvent(name, { bubbles, detail }));

  // ------------------------
  // Main
  // ------------------------
  onReady(() => {
    const drawerRoot = $('[data-drawer="drawer-cart"]');
    if (!drawerRoot) return;

    const openDrawer  = () => dispatch(drawerRoot, 'theme:drawer:open',  null, false);
    const closeDrawer = () => dispatch(drawerRoot, 'theme:drawer:close', null, false);

    // 必要コンテナ参照
    const pickParts = (rootEl) => ({
      lineItems: $('[data-line-items]', rootEl),
      subtotal : $('[data-cart-subtotal]', rootEl),
      bottom   : $('[data-cart-bottom]', rootEl),
      emptyBlk : $('[data-cart-empty]', rootEl),
      errors   : $('[data-form-errors]', rootEl),
    });

    // 差し替え（ルートは入れ替えない）
    const replaceChildren = (to, from) => {
      if (!to || !from) return;
      to.replaceChildren(...from.cloneNode(true).childNodes);
    };

    const transplant = (freshRoot) => {
      const cur = pickParts(drawerRoot);
      const nxt = pickParts(freshRoot);

      replaceChildren(cur.lineItems, nxt.lineItems);
      replaceChildren(cur.subtotal,  nxt.subtotal);
      replaceChildren(cur.bottom,    nxt.bottom);
      replaceChildren(cur.errors,    nxt.errors);

      // 空/非空のトグル
      if (cur.emptyBlk && nxt.emptyBlk) {
        const isEmpty = !nxt.emptyBlk.classList.contains('cart--hidden');
        cur.emptyBlk.classList.toggle('cart--hidden', !isEmpty);
        if (cur.bottom) cur.bottom.classList.toggle('cart--hidden', isEmpty);
      }

      // 差し替え後の軽いフェード
      const items = cur.lineItems;
      if (!items) return;
      items.classList.add('fade-in-start');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          items.classList.add('fade-in-active');
          items.classList.remove('fade-in-start');
          const onEnd = () => {
            items.removeEventListener('transitionend', onEnd);
            items.classList.remove('fade-in-active');
          };
          items.addEventListener('transitionend', onEnd, { once: true });
          setTimeout(() => items.classList.remove('fade-in-active'), 280); // フォールバック
        });
      });
    };

    // セクションHTML取得（A: ?section_id / B: ?sections）
    const fetchDrawerSectionHTML = async () => {
      const sectionEl = drawerRoot.closest('[data-section-id]');
      const sectionId = sectionEl?.getAttribute('data-section-id');
      const root      = (window.theme?.routes?.root_url) || '/';
      if (!sectionId) return null;

      try {
        const html = await fetch(`${root}?section_id=${sectionId}`, { credentials: 'same-origin' }).then(r => r.text());
        if (html?.includes('data-drawer="drawer-cart"')) return html;
      } catch (_) {}

      try {
        const json = await fetch(`${root}?sections=${sectionId}`, { credentials: 'same-origin' }).then(r => r.json());
        const html = json?.[sectionId];
        if (html?.includes('data-drawer="drawer-cart"')) return html;
      } catch (_) {}

      return null;
    };

    // ------------------------
    // 連打対策：キュー＆デバウンス
    // ------------------------
    let inflight = false;
    let queued   = false;
    let lastRun  = 0;
    const MIN_INTERVAL = 120;

    const refreshOnce = async () => {
      const html = await fetchDrawerSectionHTML();
      if (!html) return;
      const wrap = document.createElement('div');
      wrap.innerHTML = html;
      const freshRoot = $('[data-drawer="drawer-cart"]', wrap);
      if (freshRoot) transplant(freshRoot);
    };

    const runRefreshFlow = async () => {
      if (inflight) { queued = true; return; }

      const now = performance.now();
      if (now - lastRun < MIN_INTERVAL) {
        if (!queued) {
          queued = true;
          setTimeout(runRefreshFlow, MIN_INTERVAL);
        }
        return;
      }

      inflight = true;
      try {
        await refreshOnce();
        openDrawer();
        lastRun = performance.now();
      } catch (e) {
        console.warn('[custom-cart] refresh flow failed', e);
        openDrawer();
      } finally {
        inflight = false;
        if (queued) {
          queued = false;
          setTimeout(runRefreshFlow, 0);
        }
      }
    };

    // ------------------------
    // Hooks
    // ------------------------

    // テーマの「商品追加」合図
    document.addEventListener('theme:cart:popdown', runRefreshFlow);

    // /cart/add.js を使うフォームを拡張（成功時に合流）
    const enhance = (form) => {
      if (!form || form._enhanced) return;
      form._enhanced = true;

      form.addEventListener('submit', (e) => {
        if (form.hasAttribute('data-no-ajax')) return;
        e.preventDefault();

        // ダブルPOST防止（短時間だけロック）
        const btn = e.submitter || form.querySelector('[type="submit"], button, [role="button"]');
        if (btn && !btn.disabled) {
          btn.disabled = true;
          setTimeout(() => { btn.disabled = false; }, 400);
        }

        const fd = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: fd
        })
          .then(r => r.json())
          .then(runRefreshFlow)
          .catch(() => form.submit());
      });
    };

    $$('form[action^="/cart/add"]').forEach(enhance);
    new MutationObserver((muts) => {
      muts.forEach((m) => m.addedNodes.forEach((node) => {
        if (node.querySelectorAll) node.querySelectorAll('form[action^="/cart/add"]').forEach(enhance);
      }));
    }).observe(document.documentElement, { childList: true, subtree: true });

    // 「戻る / ショッピングを続ける」＝ ドロワーを閉じるだけ
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-continue-shopping]');
      if (!trigger) return;
      e.preventDefault();
      closeDrawer();
    });

    // キーボード操作（Enter / Space）でも同挙動
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const active = document.activeElement;
      if (!active || !active.closest('[data-continue-shopping]')) return;
      e.preventDefault();
      closeDrawer();
    });
  });
})();

/* ==========================================================================
   Featured product (home page only): show a short description
   --------------------------------------------------------------------------
   The home page "Featured product" section prints the whole product
   description (FEATURE / DETAIL / ATTENTION). Everything from the first <h3>
   onwards is hidden and a "MORE DETAIL" text link to the product page is
   appended instead. Product pages (/products/...) are never touched.
   ========================================================================== */
(function () {
  'use strict';

  var LINK_CLASS = 'spw-more-detail';
  var HIDE_CLASS = 'spw-detail-hidden';
  var DESC_SELECTOR = '.product__block__description.rte';

  function isHomeTemplate() {
    var body = document.body;
    if (!body || !body.classList) return false;
    // <body class="template-{{ template | ... | handle }} ..."> in layout/theme.liquid
    if (body.classList.contains('template-product')) return false;
    return body.classList.contains('template-index');
  }

  function findProductUrl(scope) {
    // snippets/product-title.liquid renders the title as a link whenever the
    // section is not on a product template.
    var candidates = [
      '.product__block__title a[href]',
      '.product__title a[href]',
      'a[href*="/products/"]'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = scope.querySelector(candidates[i]);
      var href = el && el.getAttribute('href');
      if (href && href.indexOf('/products/') !== -1) return href;
    }
    return null;
  }

  function shorten(container) {
    if (!container || container.querySelector('.' + LINK_CLASS)) return;

    var scope = container.closest('.shopify-section') || container.parentElement;
    if (!scope) return;

    // The description markup sits inside .product-description__content when the
    // block uses the "read more" style, otherwise straight inside the rte box.
    var body = container.querySelector('.product-description__content') || container;
    var firstHeading = body.querySelector('h3');
    if (!firstHeading) return;

    var url = findProductUrl(scope);
    if (!url) return; // no reliable product link -> change nothing

    var node = firstHeading;
    while (node) {
      if (node.classList) node.classList.add(HIDE_CLASS);
      node.hidden = true;
      node = node.nextElementSibling;
    }

    // The theme clamps the description and shows its own "read more" control.
    // With the tail hidden there is nothing left to expand.
    var holder = container.querySelector('.product-description__holder');
    if (holder) holder.classList.remove('product-description__holder--truncate');
    var actions = container.querySelector('.product-description__actions');
    if (actions) {
      actions.classList.add(HIDE_CLASS);
      actions.hidden = true;
    }

    var link = document.createElement('a');
    link.className = LINK_CLASS;
    link.setAttribute('href', url);
    link.textContent = 'MORE DETAIL';
    container.appendChild(link);
  }

  function run(root) {
    if (!isHomeTemplate()) return;
    var scope = root && root.querySelectorAll ? root : document;
    var blocks = scope.querySelectorAll(DESC_SELECTOR);
    for (var i = 0; i < blocks.length; i++) shorten(blocks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }

  // Theme editor re-renders a section without reloading the page.
  document.addEventListener('shopify:section:load', function (event) {
    run(event.target || document);
  });
})();
